import api from '@/api';

const contractWorkDetail = {
  namespaced: true,

  state() {
    return {
      isLoading: true,
      paymentTermsOptions: [],
      visibilityOptions: [],
      workTypesOptions: [],
      typesOptions: [],
      statusOptions: [],
      taxationTypeOptions: [],
    };
  },

  mutations: {
    setTypes(state, payload) {
      const data = payload.customerParameters || {};
      if (data.types) {
        state.typesOptions = data.types.map((item) => ({
          label: item.name,
          value: item.engName,
        }));
      }
    },
    setWorkTypes(state, payload) {
      const data = payload.customerParameters || {};
      if (data.workTypes) {
        state.workTypesOptions = data.workTypes.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      }
    },
    setPaymentTerms(state, payload) {
      const data = payload.customerParameters || {};
      if (data.paymentTerms) {
        state.paymentTermsOptions = data.paymentTerms.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      }
    },
    setVisibility(state, payload) {
      const data = payload.customerParameters || {};
      if (data.visibility) {
        state.visibilityOptions = data.visibility.map((item) => ({
          label: item.name,
          value: item.engName,
        }));
      }
    },
    setStatusOptions(state, payload) {
      const data = payload.customerParameters || {};
      if (data.status) {
        state.statusOptions = data.status.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      }
    },
    setTaxationType(state, payload) {
      const data = payload.customerParameters || {};
      if (data.taxationType) {
        state.taxationTypeOptions = data.taxationType.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      }
    },
    changeLoading(state, status) {
      state.isLoading = status;
    },
  },

  actions: {
    async getCustomerOptions({ commit, rootState }) {
      try {
        commit('changeLoading', true);
        const { isLoggedIn } = rootState.user;

        if (!isLoggedIn) {
          return;
        }

        const customerParameters = await api.contractWorks.customer.parameters();
        commit('setTypes', { customerParameters });
        commit('setWorkTypes', { customerParameters });
        commit('setPaymentTerms', { customerParameters });
        commit('setVisibility', { customerParameters });
        commit('setStatusOptions', { customerParameters });
        commit('setTaxationType', { customerParameters });
      } catch (e) {
        console.error(e);
        commit('setTypes', {});
        commit('setWorkTypes', {});
        commit('setPaymentTerms', {});
        commit('setVisibility', {});
        commit('setStatusOptions', {});
        commit('setTaxationType', {});
      } finally {
        commit('changeLoading', false);
      }
    },
  },
};

export default contractWorkDetail;
